import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
    <script src="https://cdn.tailwindcss.com"></script>

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <App />

  </StrictMode>
);
